import { AmountUtils, DateUtils } from '@shared/utils';
import type { GetCardAccountBalanceReportResponse } from '@shared/api/rest/accounts';
import { Table, TableCellType } from '@shared/widgets';

interface IAccountTableProps {
  isLoading?: boolean;
  accounts: GetCardAccountBalanceReportResponse[];
  currentPage: number;
  totalItemCount: number;
  countItemPage: number;
  onChangePage: (pageNumber: number) => void;
  onChangeCountItemPage: (pageNumber: number) => void;
}
export const AccountTable = (props: IAccountTableProps) => {
  return (
    <Table
      columns={['date', 'account label', 'currency', 'available balance']}
      items={props.accounts.map((x) => {
        return [
          {
            type: TableCellType.Text,
            value: DateUtils.formatDate(x.dateCreated),
          },
          {
            type: TableCellType.Text,
            value: x.accountName.replaceAll('X', '*'),
          },
          {
            type: TableCellType.Text,
            value: x.currency.toUpperCase(),
          },
          {
            type: TableCellType.Text,
            value: AmountUtils.transformToAmountWithCurrency(x.availableBalance, x.currency),
          },
        ];
      })}
      pagination={{
        currentPage: props.currentPage,
        totalItemCount: props.totalItemCount,
        countItemPage: props.countItemPage,
        onChangePage: props.onChangePage,
        onChangeCountItemPage: props.onChangeCountItemPage,
      }}
      isLoading={props.isLoading}
      isScrollable
    />
  );
};
